import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.css', '../edito.css']
})
export class BrandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
